export const authMobileNavigationList = [
  { id: "home", icon: "🏠", label: "Home", href: "" },
  { id: "challenges", icon: "⚡", label: "Play", href: "challenges" },
  { id: "markets", icon: "📈", label: "Markets", href: "markets" },
  { id: "badges", icon: "🏆", label: "Badges", href: "badges" },
  { id: "leaderboard", icon: "👑", label: "Rank", href: "leaderboard" },
];

export const notAuthMobileNavigationList = [
  { id: "home", icon: "🏠", label: "Home", href: "" },
  { id: "challenges", icon: "⚡", label: "Play", href: "challenges" },
  { id: "markets", icon: "📈", label: "Markets", href: "markets" },
];
